var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrollbar"},[_c('el-menu',{staticClass:"menu",attrs:{"default-active":_vm.activeMenu,"router":true,"background-color":"#303133","text-color":"#fff","active-text-color":"#446cf3"}},_vm._l((_vm.menus),function(menu){return _c('MenuItem',{key:menu.path,attrs:{"item":menu}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }